
import CardReceive from "../../../assets/filled/CardReceive.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CardReceiveIcon({ className, dataTestid = "CardReceiveIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <CardReceive data-testid={dataTestid} className={classes} {...rest} />
  );
}
